import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { toList34jp97o2ftj8p as toList } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Collection.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Paire9pteg33gng7 as Pair } from '../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import {
  first58ocm7j58k3q as first,
  drop3na99dw9feawf as drop,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { DefaultApolloException8w3ielfxng0h as DefaultApolloException } from '../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/exception/Exceptions.mjs';
import { ensureNotNull1e947j3ixpazm as ensureNotNull } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { addSuppressedu5jwjfvsc039 as addSuppressed } from '../../../../kotlin-kotlin-stdlib/kotlin/throwableExtensions.mjs';
import { createThis2j2avj17cvnv2 as createThis } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Builder32honxq3tatym as Builder } from '../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/ApolloRequest.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *singleSuccessOrException($this, flow, $completion) {
  var responses = yield* toList(flow, VOID, $completion);
  // Inline function 'kotlin.collections.partition' call
  var first_0 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
  var second = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
  var _iterator__ex2g4s = responses.iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    if (!(element.exception_1 == null)) {
      first_0.add_utx5q5_k$(element);
    } else {
      second.add_utx5q5_k$(element);
    }
  }
  var _destruct__k2r9zo = new (Pair())(first_0, second);
  var exceptionResponses = _destruct__k2r9zo.component1_7eebsc_k$();
  var successResponses = _destruct__k2r9zo.component2_7eebsb_k$();
  var tmp;
  if (successResponses.get_size_woubt6_k$() === 0) {
    var tmp_0;
    switch (exceptionResponses.get_size_woubt6_k$()) {
      case 0:
        throw DefaultApolloException().new_com_apollographql_apollo_exception_DefaultApolloException_6xe6ia_k$('The operation did not emit any item, check your interceptor chain');
      case 1:
        tmp_0 = first(exceptionResponses);
        break;
      default:
        var first_1 = first(exceptionResponses);
        var tmp_1 = first_1.newBuilder_dnl2aj_k$();
        var tmp0 = drop(exceptionResponses, 1);
        // Inline function 'kotlin.collections.fold' call

        var accumulator = ensureNotNull(first_1.exception_1);
        var _iterator__ex2g4s_0 = tmp0.iterator_jk1svi_k$();
        while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
          var element_0 = _iterator__ex2g4s_0.next_20eer_k$();
          // Inline function 'kotlin.also' call
          var this_0 = accumulator;
          addSuppressed(this_0, ensureNotNull(element_0.exception_1));
          accumulator = this_0;
        }

        var tmp$ret$2 = accumulator;
        tmp_0 = tmp_1.exception_5qwc7n_k$(tmp$ret$2).build_1k0s4u_k$();
        break;
    }
    tmp = tmp_0;
  } else {
    tmp = first(successResponses);
  }
  return tmp;
}
var ApolloCallClass;
function ApolloCall() {
  if (ApolloCallClass === VOID) {
    class $ {
      constructor(apolloClient, requestBuilder) {
        return new.target.new_com_apollographql_apollo_ApolloCall_ce0kd9_k$(apolloClient, requestBuilder);
      }
      static new_com_apollographql_apollo_ApolloCall_ce0kd9_k$(apolloClient, requestBuilder) {
        var $this = createThis(this);
        $this.apolloClient_1 = apolloClient;
        $this.requestBuilder_1 = requestBuilder;
        return $this;
      }
      static new_com_apollographql_apollo_ApolloCall_d8sxd7_k$(apolloClient, operation) {
        return this.new_com_apollographql_apollo_ApolloCall_ce0kd9_k$(apolloClient, new (Builder())(operation));
      }
      addHttpHeader_irkgza_k$(name, value) {
        // Inline function 'kotlin.apply' call
        this.requestBuilder_1.addHttpHeader_irkgza_k$(name, value);
        return this;
      }
      toFlow_edjqgn_k$() {
        return this.apolloClient_1.executeAsFlowInternal_ds6yfe_k$(this.requestBuilder_1.build_1k0s4u_k$(), false);
      }
      *execute_ar693i_k$($completion) {
        return yield* /*#__NOINLINE__*/singleSuccessOrException(this, this.toFlow_edjqgn_k$(), $completion);
      }
    }
    initMetadataForClass($, 'ApolloCall', VOID, VOID, VOID, [0, 1]);
    ApolloCallClass = $;
  }
  return ApolloCallClass;
}
//region block: exports
export {
  ApolloCall as ApolloCallpwdxdy18rzuy,
};
//endregion

//# sourceMappingURL=ApolloCall.mjs.map
